import { motion } from "framer-motion";
import classes from "../More.module.css";

const PrivacyPolicy = () => {
  return (
    <motion.div
      className={classes.page}
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <h1>Privacy Policy</h1>
<p>Effective Date: September 28, 2025</p>

<p>
At <strong>dothink</strong>, your privacy is important to us. This Privacy Policy
explains what information we collect, how we use it, and the choices you have
regarding your data when using our services.
</p>

<h2>1. Information We Collect</h2>
<p>We may collect the following information when you use our app:</p>
<ul>
  <li><strong>Account Information</strong>: Name, email address, and login credentials.</li>
  <li><strong>Usage Data</strong>: Interactions with the app (e.g., questions, answers, and activity within mindmaps).</li>
  <li><strong>Device Data</strong>: IP address, browser type, and operating system (collected automatically for security and analytics).</li>
  <li><strong>Contact Submissions</strong>: Messages you send to us (e.g., through the “Contact Us” form).</li>
</ul>

<h2>2. How We Use Your Information</h2>
<p>We use your information for the following purposes:</p>
<ul>
  <li>To provide and improve our services.</li>
  <li>To personalize your experience within the app.</li>
  <li>To communicate with you (e.g., account updates, support, or announcements).</li>
  <li>To monitor usage and maintain security of the platform.</li>
  <li>To comply with legal obligations.</li>
</ul>

<h2>3. How We Share Information</h2>
<p>We do not sell your personal information. We may share information only in the following cases:</p>
<ul>
  <li><strong>With Service Providers</strong>: Trusted third parties who help us operate and improve our app (e.g., Firebase, hosting, analytics).</li>
  <li><strong>For Legal Reasons</strong>: If required by law, regulation, or legal process, or to protect the rights, property, or safety of dothink and its users.</li>
</ul>

<h2>4. Data Storage & Security</h2>
<p>
Your information is stored securely using trusted cloud services such as Google Firebase. 
We implement reasonable technical and organizational measures to protect your data from 
unauthorized access, use, or disclosure. However, no online service is 100% secure, and we 
cannot guarantee absolute security.
</p>

<h2>5. Your Rights</h2>
<p>You have the following rights regarding your personal data:</p>
<ul>
  <li>Access: You can request a copy of the data we hold about you.</li>
  <li>Correction: You can request corrections to inaccurate or incomplete data.</li>
  <li>Deletion: You can request deletion of your account and associated data.</li>
  <li>Withdrawal of Consent: Where processing is based on consent, you may withdraw it at any time.</li>
</ul>
<p>
To exercise these rights, contact us at <strong>james@1023417@gmail.com</strong>.
</p>

<h2>6. Children's Privacy</h2>
<p>
Our services are not directed at children under 13 (or the age required in your jurisdiction). 
We do not knowingly collect personal data from children. If we learn that we have collected 
data from a child without proper consent, we will delete it immediately.
</p>

<h2>7. Changes to This Policy</h2>
<p>
We may update this Privacy Policy from time to time. If significant changes are made, 
we will notify users through the app or by email. Please review this page periodically.
</p>

<h2>8. Contact Us</h2>
<p>
If you have any questions or concerns about this Privacy Policy, please contact us at:
<strong> james1023417@gmail.com</strong>.
</p>

    </motion.div>
  );
};

export default PrivacyPolicy;
